import { render, staticRenderFns } from "./AdministrativePermitsQuickTable.vue?vue&type=template&id=35086223&scoped=true"
import script from "./AdministrativePermitsQuickTable.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsQuickTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35086223",
  null
  
)

export default component.exports